export default __webpack_public_path__ + "static/media/search.88c742b1.png";